import { render, staticRenderFns } from "./MaterialsTab.vue?vue&type=template&id=96e544f4&"
import script from "./MaterialsTab.vue?vue&type=script&lang=ts&"
export * from "./MaterialsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports